import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { AgentSubjectType } from 'shared/domains/apollo/generated/types';
import { useTableContext } from '../SearchResultsTable/TableContext';
import { useCreateActionEventHandlers } from '../SearchResultsTable/useCreateActionEventHandlers';
import { isDocument } from '../SearchResultsTable/utils';
export function Assistant() {
    const { selected } = useTableContext();
    const history = useHistory();
    const { isFeatureAvailable } = useCompanyFeatures();
    const agent = isFeatureAvailable('AGENT');
    const enabled = agent || isFeatureAvailable('PLAI_AGENT');
    const documents = selected.filter(isDocument);
    const eligibleDocumentsCount = documents.length;
    const disabled = !eligibleDocumentsCount;
    const eventHandlers = useCreateActionEventHandlers('plai', () => {
        if (agent) {
            const state = {
                attachments: documents.map(({ entityId, name }) => ({
                    id: entityId,
                    name,
                    type: AgentSubjectType.Document,
                })),
            };
            history.push({ pathname: '/agent', state });
            return;
        }
        history.push({
            pathname: '/plai/chat',
            state: { documentId: documents.map(({ entityId }) => entityId) },
        });
    });
    if (!enabled) {
        return null;
    }
    return (<Button type="button" size="small" disabled={disabled} appearance="glass" {...eventHandlers}>
      <Falcon icon="sparkles"/>
      {agent ? (<Trans comment="Bulk action: Agent" context="search">
          Agent
        </Trans>) : (<Trans comment="Bulk action: Assistant" context="search">
          PLAI
        </Trans>)}
    </Button>);
}
